import React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { message, Icon } from 'antd'
import { withRouter, Link } from 'react-router-dom'
import classnames from 'classnames'
import { refresh_profile } from '../../../actions/auth'

import AmazonS3Logo from '../../../assets/logo/partner-logo-Amazon.svg'
import WasabiLogo from '../../../assets/logo/partner-logo-Wasabi.svg'
import AzureLogo from '../../../assets/logo/partner-logo-Azure.svg'
import BackblazeLogo from '../../../assets/logo/partner-logo-BackBlaze.svg'
import GenericS3Logo from '../../../assets/logo/genericS3.svg'
import GoogleLogo from '../../../assets/logo/logo-google-cloud.png'
import FileBaseLogo from '../../../assets/logo/filebase-logo.png'

import CloudFlyerAPI from '../../../api/CloudFlyerAPI'
import AddAws from '../../../components/CloudProviders/Aws/addAws'
import AddGoogle from '../../../components/CloudProviders/Google/addGoogle'
import SetBillingBucket from '../../../components/CloudProviders/Aws/setBillingBucket'
import AddWasabi from '../../../components/CloudProviders/Wasabi/addWasabi'
import AddAzure from '../../../components/CloudProviders/Azure/AddAzure'
import AddBackblaze from '../../../components/CloudProviders/Backblaze/AddBackblaze'
import GenericS3 from '../../../components/CloudProviders/GenericS3/addGeneric'
import AddFilebase from '../../../components/CloudProviders/Filebase/addFilebase'

import ModalB                             from '../../../components/UI/Modal/ModalB'
import Backdrop                           from '../../../components/UI/Backdrop/Backdrop';
import warningIcon                        from '../../../assets/img/warning.png';

import './styles.scss'

const defaultParams = {
    provider: 'aws',
    region: 'us-east-1',
    accountTypeId: 1,
}

class AddProvider extends React.Component {
    constructor(props) {
        super(props)

        const { item, match } = props

        const edit = item !== undefined

        let currentUser = JSON.parse(localStorage.getItem('user'))
        
        
        let providers = []

        if(currentUser.userType == 4){
            providers = [
                {
                    id: 1,
                    name: 'aws',
                    img: AmazonS3Logo,
                    enabled: true,
                },
                {
                    name: 'azure',
                    img: AzureLogo,
                    enabled: true,
                },
                {
                    name: 'google',
                    img: GoogleLogo,
                    enabled: true
                },
                {
                    name: 'filebase',
                    img: FileBaseLogo,
                    enabled: true,
                },
                {
                    name: 'wasabi',
                    img: WasabiLogo,
                    enabled: true,
                },
                {
                    name: 'genericS3',
                    img: GenericS3Logo,
                    enabled: true
                }
            ]
        }
        else
        {
            providers = [
                {
                    name: 'wasabi',
                    img: WasabiLogo,
                    enabled: true,
                }
            ]
        }


        this.state = {
            accountAdded: false, // used to allow navigation, in case the created account is the first one
            firstAccount: false,
            item,
            edit,
            selectedProvider: 'aws',
            loadingSave: false,
            billing_bucket:
                edit && item
                    ? item.billing_bucket
                        ? item.billing_bucket
                        : item.storages[0]
                        ? item.storages[0].name
                        : ''
                    : null,
            disabledSave: !edit,
            setupForm: edit
                ? {
                      access_key_id: (item.info || {}).access_key,
                      secret_access_key: (item.info || {}).secret_key,
                      project_name: item.project_name,
                  }
                : {},

            providers: providers,
            activeWasabiTab: 'add',
            id: null,
            // POP UP
            popUp: false,
            popUpMessage: null,
        }

        this.handleProviderSelect = this.handleProviderSelect.bind(this)
        this.handleInputChange = this.handleInputChange.bind(this)
        this.handleSaveClick = this.handleSaveClick.bind(this)
        this.handleUpdateClick = this.handleUpdateClick.bind(this)
        this.handleError = this.handleError.bind(this)
        this.handleReceiveId = this.handleReceiveId.bind(this)
    }

    componentDidMount() {
        const { history } = this.props

    }

    handleProviderSelect(provider) {
        if (!provider.enabled) {
            return
        }
        this.setState({
            selectedProvider: provider.name,
            setupForm:{},
            disabledSave:true
        })
    }

    handleInputChange(e) {
        const { name, value } = e.target
        const { setupForm } = this.state

        const newSetupForm = { ...setupForm, [name]: value }
        const fields = Object.keys(newSetupForm)
        var totalFields = 3;
        if(this.state.selectedProvider === "google"){
            totalFields = 2;
        }
        if(this.state.selectedProvider === "genericS3"){
            totalFields = 4;
        }
        const disabledSave =
            fields.length < totalFields ||
            fields.some(field => newSetupForm[field].length === 0)

        this.setState({
            setupForm: newSetupForm,
            disabledSave,
        })
    }

    handleSaveClick(onSave) {
        // TODO: it's better to delay this until we get a response from the server whether the operation was successful or not
        this.setState({ accountAdded: true })

        switch (this.state.selectedProvider) {
            case 'aws':
                this.save_aws(this.state, onSave)
                break
            case 'wasabi':
                this.state.activeWasabiTab === 'create'
                    ? this.create_wasabi(this.state)
                    : this.save_wasabi(this.state)
                break
            case 'azure':
                this.save_azure(this.state)
                break
            case 'backblaze':
                this.save_backblaze(this.state)
                break
            case 'genericS3':
                this.save_generic(this.state)
                break
            case 'filebase':
                this.save_filebase(this.state)
                break
            case 'google':
                this.save_google(this.state)
                break
            default:
                console.log('Sorry, we are out of.')
        }
    }

    handleUpdateClick() {
        const { setupForm, item } = this.state
        const { history } = this.props
        this.setState({ loadingSave: true })

        CloudFlyerAPI.new_cloud_accounts
            .update(
                item.id,
                setupForm.project_name,
                null,
                this.state.billing_bucket
            )
            .then(res => {
                this.setState({ loadingSave: false })
                message.success(((res || {}).data || {}).message)
                history.push('/')
            })
            .catch(this.handleError)
    }

    save_aws = ({ setupForm }, onSave) => {
        const { project_name, access_key_id, secret_access_key } = setupForm
        
        const body = {
            cloudType: 1,
            name:project_name,
            accessKey: access_key_id,
            secretKey:secret_access_key,
        }

        this.setState({ loadingSave: true })
        const { history } = this.props

        CloudFlyerAPI.new_cloud_accounts
            .create(body)
            .then(res => {
                // TODO : uncomment this and use the real field from the real response
                message.success(project_name + ' added successfully')
                this.props.history.push(
                    this.state.firstAccount ? '/onboard/firstAccount' : '/'
                )
                // const { accounts_count } = ((res||{}).data||{});
                const accounts_count = 1
                // onSave(((res || {}).data || {}).id)
                this.setState({ loadingSave: false })
                if (accounts_count === 1) {
                    // this is the first account ever
                    this.setState({ firstAccount: true })
                }
                // this.props.refresh_profile(true)
            })
            .catch(this.handleError)

    }


    save_generic = ({ setupForm }) => {
        const { project_name, access_key_id, secret_access_key, endpoint } = setupForm
        const body = {
            cloudType: 8,
            name:project_name,
            accessKey: access_key_id,
            secretKey:secret_access_key,
            serviceUrl:endpoint
        }

        this.setState({ loadingSave: true })
        CloudFlyerAPI.new_cloud_accounts
            .create(body)
            .then(() => {
                message.success(project_name + ' added successfully.')
                this.setState({ loadingSave: false });
                this.props.history.push(
                    this.state.firstAccount ? '/onboard/firstAccount' : '/'
                )
                // this.props.refresh_profile(true)
            })
            .catch(this.handleError)
    }


    save_filebase = ({ setupForm }) => {
        const { project_name, access_key_id, secret_access_key } = setupForm
        const body = {
            cloudType: 8,
            name:project_name,
            accessKey: access_key_id,
            secretKey:secret_access_key,
            serviceUrl:'https://s3.filebase.com'
        }

        this.setState({ loadingSave: true })
        CloudFlyerAPI.new_cloud_accounts
            .create(body)
            .then(() => {
                message.success(project_name + ' added successfully.')
                this.setState({ loadingSave: false });
                this.props.history.push(
                    this.state.firstAccount ? '/onboard/firstAccount' : '/'
                )
                // this.props.refresh_profile(true)
            })
            .catch(this.handleError)
    }


    save_wasabi = ({ setupForm }) => {
        const { project_name, access_key_id, secret_access_key } = setupForm
        const body = {
            cloudType: 2,
            name:project_name,
            accessKey: access_key_id,
            secretKey:secret_access_key,
        }

        this.setState({ loadingSave: true })
        CloudFlyerAPI.new_cloud_accounts
            .create(body)
            .then(() => {
                message.success(project_name + ' added successfully.')
                this.setState({ loadingSave: false });
                this.props.history.push(
                    this.state.firstAccount ? '/onboard/firstAccount' : '/'
                )
                // this.props.refresh_profile(true)
            })
            .catch(this.handleError)
    }

    save_google = ({ setupForm }) => {
        const { project_name, credentials_data } = setupForm
        const body = {
            cloudType: 16,
            name:project_name,
            credentialsData: credentials_data
        }

        this.setState({ loadingSave: true })
        CloudFlyerAPI.new_cloud_accounts
            .create(body)
            .then(() => {
                message.success(project_name + ' added successfully.')
                this.setState({ loadingSave: false });
                this.props.history.push(
                    this.state.firstAccount ? '/onboard/firstAccount' : '/'
                )
                // this.props.refresh_profile(true)
            })
            .catch(this.handleError)
    }


    save_azure = ({ setupForm }) => {

        const {access_key_id, secret_access_key, project_name} = setupForm
        const body = {
            cloudType: 4,
            name:project_name,
            accessKey: access_key_id,
            secretKey:secret_access_key,
        }

        this.setState({ loadingSave: true })
        CloudFlyerAPI.new_cloud_accounts
            .create(body)
            .then(() => {
                message.success(project_name + ' added successfully.')
                this.setState({ loadingSave: false })
                this.props.history.push(
                    this.state.firstAccount ? '/onboard/firstAccount' : '/'
                )
                // this.props.refresh_profile(true)
            })
            .catch(this.handleError)
    }

    save_backblaze = ({ setupForm }) => {
        const {
            project_name,
            account_name,
            account_key,
            access_key_id,
            secret_access_key,
        } = setupForm

        // debugger
        const body = {
            cloud_account: {
                account_type_id: 6,
                project_name,
                info: {
                    access_key_id,
                    secret_access_key,
                    account_name,
                    account_key,
                },
            },
        }

        this.setState({ loadingSave: true })
        CloudFlyerAPI.cloud_accounts
            .create(body)
            .then(() => {
                message.success(project_name + ' added successfully.')
                this.setState({ loadingSave: false })
                this.props.history.push(
                    this.state.firstAccount ? '/onboard/firstAccount' : '/'
                )
                this.props.refresh_profile(true)
            })
            .catch(this.handleError)
    }

    create_wasabi = ({ setupForm }) => {
        const { email, password, project_name } = setupForm
        const body = {
            acct_name: email,
            password,
            project_name,
        }
        this.setState({ loadingSave: true })
        CloudFlyerAPI.wasabi
            .create(body)
            .then(() => {
                message.success('Account created successfully.')
                this.setState({ loadingSave: false })
                this.props.history.push(
                    this.state.firstAccount ? '/onboard/firstAccount' : '/'
                )
                this.props.refresh_profile(true)
            })
            .catch(this.handleError)
    }

    on_billing_bucket_change = bucket =>
        this.setState({ billing_bucket: bucket })

    handleError(e) {
        this.setState({
            popUp:false,
            popUpMessage:{
                icon:warningIcon,
                header:"Something Went Wrong",
                text:{
                    1:e.response.data.message
                },
                button:"OK"
              }})
        // message.error('Something went wrong, please try again.')
        this.setState({ loadingSave: false })
    }
    closePopUpHandler= () =>{
        this.setState({popUp:false})
    }

    handleWasabiTabChange = activeWasabiTab => {
        this.setState({ activeWasabiTab })
    }

    handleReceiveId(id) {
        this.setState({ id })
    }

    render() {
        const {
            selectedProvider,
            setupForm,
            disabledSave,
            loadingSave,
            edit,
            item,
            billing_bucket,
            providers,
            activeWasabiTab,
            popUp,
            popUpMessage
        } = this.state

        // POP UPS
        const popUpComponent = popUp ? 
        <div>
            <Backdrop show={popUp} close={this.closePopUpHandler}/>
                <ModalB 
                    show={popUp}
                    icon={popUpMessage.icon}
                    header={popUpMessage.header}
                    text={popUpMessage.text}
                    button={popUpMessage.button}
                    close={this.closePopUpHandler}
                /> 
        </div>:null;

        return (
            <div className="add-provider">
                {popUpComponent}
                <div className="header">
                    <h2>Set Up a New Cloud Provider</h2>
                    <h3>
                        <Link to="/">Close</Link>
                    </h3>
                </div>
                <div className="choose-provider">
                    <h3 className="step-header">
                        1. Choose a provider
                    </h3>
                    <div className="provider-items" >
                        {providers.map((provider, index) => (
                            <div
                                key={index}
                                className={classnames(
                                    {
                                        selected:
                                            provider.name === selectedProvider,
                                    },
                                    { disabled: !provider.enabled }
                                )}
                                onClick={this.handleProviderSelect.bind(null,provider)}
                                >
                                <img
                                    className={'provider-logo'}
                                    src={provider.img}
                                    alt=""
                                    // style={provider.name === 'backblaze' ? {padding: "0 .7rem"} : {}}
                                />
                                {/* <div className={'selection-badge'}>
                                    <Icon type="check" />
                                </div> */}
                            </div>
                        ))}
                    </div>
                </div>
                <div className="set-up">
                    <h3 className="step-header">
                        2. Set Up Access
                    </h3>
                    {selectedProvider === 'aws' ? (
                        <AddAws
                            edit={edit}
                            setupForm={setupForm}
                            disabled={disabledSave}
                            loading={loadingSave}
                            storages={item ? item.storages : []}
                            billing_bucket={billing_bucket}
                            on_billing_bucket_change={this.on_billing_bucket_change}
                            on_save={
                                edit
                                    ? this.handleUpdateClick
                                    : onSave => this.handleSaveClick(onSave)
                            }
                            on_input_change={this.handleInputChange}
                            receiveId={this.handleReceiveId}
                        />
                    ) : selectedProvider === 'wasabi' ? (
                        <AddWasabi
                            activeWasabiTab={activeWasabiTab}
                            edit={edit}
                            setupForm={setupForm}
                            disabled={disabledSave}
                            loading={loadingSave}
                            on_save={
                                edit
                                    ? this.handleUpdateClick
                                    : this.handleSaveClick
                            }
                            on_input_change={this.handleInputChange}
                            onTabChange={this.handleWasabiTabChange}
                            user={this.props.user}
                            history={this.props.history}
                        />
                    ) : selectedProvider === 'filebase' ? (
                        <AddFilebase
                            activeWasabiTab={activeWasabiTab}
                            edit={edit}
                            setupForm={setupForm}
                            disabled={disabledSave}
                            loading={loadingSave}
                            on_save={
                                edit
                                    ? this.handleUpdateClick
                                    : this.handleSaveClick
                            }
                            on_input_change={this.handleInputChange}
                            onTabChange={this.handleWasabiTabChange}
                            user={this.props.user}
                            history={this.props.history}
                        />
                    ) : selectedProvider === 'azure' ? (
                        <AddAzure
                            edit={edit}
                            setupForm={setupForm}
                            disabled={disabledSave}
                            loading={loadingSave}
                            storages={item ? item.storages : []}
                            billing_bucket={billing_bucket}
                            on_billing_bucket_change={
                                this.on_billing_bucket_change
                            }
                            on_save={
                                edit
                                    ? this.handleUpdateClick
                                    : this.handleSaveClick
                            }
                            on_input_change={this.handleInputChange}
                        />
                    ): selectedProvider === 'google' ? (
                        <AddGoogle
                            activeWasabiTab={activeWasabiTab}
                            edit={edit}
                            setupForm={setupForm}
                            disabled={disabledSave}
                            loading={loadingSave}
                            on_save={
                                edit
                                    ? this.handleUpdateClick
                                    : this.handleSaveClick
                            }
                            on_input_change={this.handleInputChange}
                            onTabChange={this.handleWasabiTabChange}
                            user={this.props.user}
                            history={this.props.history}
                        />
                    ) : selectedProvider === 'backblaze' ? (
                        <AddBackblaze
                            edit={edit}
                            setupForm={setupForm}
                            disabled={disabledSave}
                            loading={loadingSave}
                            storages={item ? item.storages : []}
                            on_save={
                                edit
                                    ? this.handleUpdateClick
                                    : onSave => this.handleSaveClick(onSave)
                            }
                            on_input_change={this.handleInputChange}
                            receiveId={this.handleReceiveId}
                        />
                    ) : selectedProvider === 'genericS3' ? (
                        <GenericS3
                            edit={edit}
                            setupForm={setupForm}
                            disabled={disabledSave}
                            loading={loadingSave}
                            // storages={item ? item.storages : []}
                            // billing_bucket={billing_bucket}
                            // on_billing_bucket_change={
                            //     this.on_billing_bucket_change
                            // }
                            on_save={
                                edit
                                    ? this.handleUpdateClick
                                    : onSave => this.handleSaveClick(onSave)
                            }
                            on_input_change={this.handleInputChange}
                            receiveId={this.handleReceiveId}
                        />
                    ) :null}

                </div>
                {this.state.id && (
                    <div className="set-bb-container">
                        <h3 className="step-header">
                            <span>3</span>Set Up Billing Bucket
                        </h3>
                        {selectedProvider === 'aws' && (
                            <SetBillingBucket
                                id={this.state.id}
                                firstAccount={this.state.firstAccount}
                            />
                        )}
                    </div>
                )}
            </div>
        )
    }
}

function validate(field) {
    return field !== undefined && field.length === 0
}

const mapStateToProps = ({ cloudAccounts, auth: { user } }, { match }) => {
    return {
        // item:
        //     match.params.id &&
        //     cloudAccounts.items.find(i => i.id === parseFloat(match.params.id)),
        // cloudAccounts,
        user,
    }
}

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      refresh_profile,
    },
    dispatch
  )

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(AddProvider))
